import * as React from "react";
import * as questionIds from "@teamprevent/common/questionnaires/questionnaireConfig/genericCase/questionIds";
import { ContextAwareProgressBarQuestionnaireSection } from "@teamprevent/common/questionnaires/components/ContextAwareProgressBarQuestionnaireSection";
import { QuestionConfig, getQuestionConfig } from "@teamprevent/common/questionnaires/questionnaireConfig";
import { TextQuestion } from "@teamprevent/common/questionnaires/components/questions/TextQuestion";
import { validators } from "not-valid";

import { furtherInformationSectionId } from "../GenericCaseForm";

interface Props {
    questionConfigs: QuestionConfig[];
    readonly: boolean;
}

export const FurtherInformationSection: React.FunctionComponent<Props> = (
    {
        questionConfigs,
        readonly
    }) => {

    return (
        <ContextAwareProgressBarQuestionnaireSection id={furtherInformationSectionId} title="Further Information">
            <TextQuestion
                questionConfig={getQuestionConfig(questionConfigs, questionIds.FurtherInformation)}
                multiline
                readonly={readonly}
                hideDivider={true}
                validators={[validators.validLength({ max: 500, message: "Maximum of 500 characters only" })]}
            />
        </ContextAwareProgressBarQuestionnaireSection>
    );
};
